import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLeaf = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "2.5em",
	height: "2.5em",
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M15 16C19.2 11.8 30 10 30 10C30 10 28.6 20.4 24 25C19.1 29.9 13.3 26.7 13.3 26.7C13.3 26.7 9.99997 21 15 16Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeMiterlimit: 10,
		strokeLinecap: "square"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M21 19L10 30",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeMiterlimit: 10,
		strokeLinecap: "square"
	})]
});
const ForwardRef = forwardRef(SvgLeaf);
export default ForwardRef;
